import { LorebookVisibility } from "@next-platform/packages-ts-types";
function getLorebookProfileIndicatorData(lorebooks, isCreator) {
    if (!lorebooks?.length) {
        return null;
    }
    const lorebook = isCreator ? lorebooks[0] : (lorebooks.find((entry) => entry?.visibility === LorebookVisibility.PUBLIC) ?? lorebooks[0]);
    if (!lorebook)
        return null;
    const isPublic = lorebook?.visibility === LorebookVisibility.PUBLIC;
    const isInteractionDisabled = !isCreator && !isPublic;
    return {
        id: lorebook?.id ?? null,
        name: lorebook?.name ?? "",
        isPrivate: !isPublic,
        isInteractionDisabled,
        canNavigate: !isInteractionDisabled && Boolean(lorebook?.id),
    };
}
export { getLorebookProfileIndicatorData };
